import { Component } from "@angular/core";
import { toastrService } from "../../services/ux/toastr.service";

@Component({
  templateUrl: "./service-contract-business.html"
})
export class ServiceContractComponent {
  constructor(public toastr: toastrService) {}
}
